var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full px-2 rounded-full text-xs flex items-center break-words",class:`${_vm.color}`},[_c('span',{staticClass:"uppercase"},[_vm._t("default",function(){return [_vm._v("Status")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }